import { getFrontendConfigLoader } from '@doxyme/config';

let isRegistered = false;

const VERSIONING_SW_PATH = '/v2/sw.js';

export function registerVersioningServiceWorker() {
  const isServerSide = typeof window === 'undefined';
  const useVersioningFeature =
    getFrontendConfigLoader().get('USE_VERSIONING_SERVICE_WORKER') ?? 'true';
  const isFeatureEnabled = useVersioningFeature === 'true';

  if (isServerSide || isRegistered || !isFeatureEnabled) {
    return;
  }

  if (!('serviceWorker' in navigator)) {
    console.warn('Service Worker is not supported in this browser.');
    return;
  }

  isRegistered = true;

  navigator.serviceWorker
    .register(VERSIONING_SW_PATH)
    .then((registration) => {
      console.log('Service Worker registered:', registration);

      return registration;
    })
    .catch((error) => {
      console.error('Service Worker registration failed:', error);
      isRegistered = false;
    });
}
